import { render, staticRenderFns } from "./ProductOneClickUpsell.vue?vue&type=template&id=146fb6c2&scoped=true&"
import script from "./ProductOneClickUpsell.vue?vue&type=script&lang=js&"
export * from "./ProductOneClickUpsell.vue?vue&type=script&lang=js&"
import style0 from "./ProductOneClickUpsell.vue?vue&type=style&index=0&id=146fb6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146fb6c2",
  null
  
)

export default component.exports